import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { inject } from '@angular/core';
import { RouterConstants } from '../_models/router-constants';
import { Backend } from '../_models/backend';
import { isEmptyObject } from '../_shared/helper';
import Role = Backend.Role;

export const canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  return checkAuth(state.url, route.data.roles);
}

export const canActivateChild = (childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  let routeCanBeActivated: Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree = false;

  let pathNode: ActivatedRouteSnapshot | null = childRoute;
  let data = pathNode.data;

  while (isEmptyObject(data) && pathNode.parent != null) {
    pathNode = pathNode.parent;
    data = pathNode.data;
  }

  if (!isEmptyObject(data)) {
    routeCanBeActivated = canActivate(pathNode, state);
  }

  return routeCanBeActivated;
}

export const canLoad = (route: Route, segments: UrlSegment[]) => {
  return checkAuth(segments.join('/'), route.data?.roles);
}

const checkAuth = (currentUrl: string | undefined, roles: Role[] | undefined) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.checkUser(roles)) {
    // logged in and valid role so return true
    return true;
  }
  // not logged in so redirect to login or board register page with the return url
  const url = roles?.includes('ROLE_BOARD') ? RouterConstants.BOARD_REGISTER : RouterConstants.LOGIN;
  return router.createUrlTree(['/' + url], {queryParams: {returnUrl: currentUrl}});
}
